import PropTypes from 'prop-types';
import './Checkbox.scss';

const Checkbox = ({ onChange, checked, title }) => (
  <div className="containerPrincipal">
    <input
      checked={checked}
      className={checked ? 'checked form-check-input' : 'not-checked form-check-input'}
      id="flexCheckChecked"
      onChange={onChange}
      type="checkbox"
    />
    {title ? <div className="titleBox">{title}</div> : <></>}
  </div>
);

Checkbox.propTypes = {
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  title: PropTypes.string
};

Checkbox.defaultProps = {
  onChange: () => {
    /* empty */
  },
  checked: false,
  title: ''
};

export default Checkbox;
